"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMessageOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 5C4.43 5 2 11 2 16c0 4.58 2.07 7.89 6 9.6v6.33L15 27h1c11.57 0 14-6 14-11S27.57 5 16 5zm0 20h-1.6L10 28.07v-3.84L9.35 24C5.75 22.64 4 20 4 16c0-6.06 3.93-9 12-9s12 3 12 9-3.92 9-12 9z" }),
        React.createElement("path", { d: "M11 13h9.99v2H11zM11 17h5.99v2H11z" })));
}
exports.default = SvgMessageOutline;
//# sourceMappingURL=MessageOutline.js.map